/* ============================================
   GLOMESH — Main JS
   Replaces custom.js (930 lines) with clean code.
   No DOM hacking. No MutationObservers on body.
   ============================================ */

(function() {
  'use strict';

  /* BUILD STAMP — verify the running code in one glance:
     view-source / devtools: <html data-gm-build>, or console. */
  try {
    document.documentElement.setAttribute('data-gm-build', '4HE');
    if (window.console && console.info) console.info('glomesh build 4GC');
  } catch (x) {}

  /* ── 4AW: exact-spot back/forward restoration, any depth ─────────────────
     Every page continuously records its scroll position keyed by URL; on
     back/forward navigation the position is restored after layout settles
     (re-applied twice to survive late image/webfont reflow). */
  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var gmScrollKey = 'gm-scroll:' + location.pathname + location.search;
    window.addEventListener('scroll', function () {
      try { sessionStorage.setItem(gmScrollKey, String(window.scrollY)); } catch (x) {}
    }, { passive: true });
    /* 4DN: restores happen behind a veil — the page scrolls while invisible and
       reveals already in position. No leap, no mid-flight flash. */
    var gmPendingRestore = (function () {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var isBack = nav ? nav.type === 'back_forward' : false;
      var homeFlag = false;
      try { homeFlag = sessionStorage.getItem('gm-home-restore') === '1'; } catch (x) {}
      isBack = isBack || (homeFlag && (location.pathname === '/' || location.pathname === ''));
      var y = parseFloat((function(){ try { return sessionStorage.getItem(gmScrollKey); } catch (x) { return null; } })() || '0');
      return isBack && y > 0;
    })();
    var gmVeilOff = function () {
      /* 4FH: the veil is an injected style (#gm-veil) — remove it; legacy
         inline clears kept for any straggler state. */
      var n = document.getElementById('gm-veil');
      if (n && n.parentNode) n.parentNode.removeChild(n);
      document.documentElement.style.transition = '';
      document.documentElement.style.opacity = '';
    };
    if (gmPendingRestore) {
      if (!document.getElementById('gm-veil')) {
        var gvs = document.createElement('style');
        gvs.id = 'gm-veil';
        gvs.textContent = 'html{background:#1C1611 !important}body{opacity:0 !important;transition:none !important}';
        document.head.appendChild(gvs);
      }
      window.setTimeout(gmVeilOff, 600); /* failsafe: never stay veiled */
    }
    var gmRestore = function () {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var isBack = nav ? nav.type === 'back_forward' : false;
      /* 4BD: a logo trip to the menu counts as a return — restore the spot even
         though it's a fresh navigation. */
      var homeFlag = false;
      try { homeFlag = sessionStorage.getItem('gm-home-restore') === '1'; sessionStorage.removeItem('gm-home-restore'); } catch (x) {}
      isBack = isBack || (homeFlag && (location.pathname === '/' || location.pathname === ''));
      var y = parseFloat((function(){ try { return sessionStorage.getItem(gmScrollKey); } catch (x) { return null; } })() || '0');
      /* 4DW: restore condition mirrors the veil — plain-navigation returns to
         the menu (same-origin referred) reposition too, so a veiled arrival is
         always an actually-positioned one. */
      var referred = false;
      try { referred = sessionStorage.getItem('gm-nav') === '1'; sessionStorage.removeItem('gm-nav'); } catch (x) {}
      /* 4EH: carried scroll wins — a continuity link (colourway switch) hands
         its exact position to this page. Otherwise ANY internal hop restores
         this URL's own stored spot. Exact-spot, everywhere. */
      var carry = 0;
      try { carry = parseFloat(sessionStorage.getItem('gm-carry') || '0'); sessionStorage.removeItem('gm-carry'); } catch (x) {}
      /* 4FG: element anchor beats numeric carry — re-seat the served-in strip
         at the same viewport offset it left, whatever this page's height above
         it. Numeric carry remains the fallback. */
      var anchorVT = NaN;
      try { anchorVT = parseFloat(sessionStorage.getItem('gm-carry-anchor')); sessionStorage.removeItem('gm-carry-anchor'); } catch (x) {}
      if (referred && !isNaN(anchorVT)) {
        var stripHere = document.querySelector('.g-dish__served');
        if (stripHere) {
          var target = Math.max(0, Math.round(stripHere.getBoundingClientRect().top + window.scrollY - anchorVT));
          y = target;
        } else if (carry > 0) { y = carry; }
      } else if (carry > 0 && referred) { y = carry; }
      window.__gmEffectiveY = y;
      if ((isBack || (referred && (carry > 0 || !isNaN(anchorVT)))) && y > 0) {
        var go = function () { window.scrollTo(0, y); };
        go();
        requestAnimationFrame(go);
        /* 4EG: the veil lifts at the settle point — the last late-layout window
           closes before anything is visible. Drift-gated re-asserts stand. */
        /* 4FB: once a preview reopen has reflowed the rows, the stored number
           is stale and the browser's anchoring holds the true spot — late
           re-asserts yield. */
        var settle = function () {
          if (window.__gmPreviewReflow) return;
          if (Math.abs(window.scrollY - y) > 2) go();
        };
        window.setTimeout(function () { settle(); gmVeilOff(); }, 140);
        window.setTimeout(settle, 450);
      } else {
        gmVeilOff();
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gmRestore);
    else gmRestore();
    window.addEventListener('load', function () {
      /* F1 (Code review): this late re-assert now carries the same yields as
         the 140/450 settles — never fights a preview-reflow's anchoring, and
         only corrects genuine drift. */
      if (window.__gmPreviewReflow) return;
      var y = window.__gmEffectiveY || parseFloat((function(){ try { return sessionStorage.getItem(gmScrollKey); } catch (x) { return null; } })() || '0');
      if (gmPendingRestore && y > 0 && Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { gmVeilOff(); } });
  } catch (err) {}

  /* ── Mobile menu ── */
  /* 4BG: old mobile slide-nav JS removed with its markup. */

  /* 4DA: header search removed — the menu card's looking-for line is the one
     search; the door (logo/back) is the way to it from every other page. */

  /* 4BD: any header-logo click flags the next homepage load to restore the
     exact list position. */
  document.addEventListener('click', function (e) {
    var logo = e.target.closest('.g-header__logo, [data-menu-home]');
    if (!logo) return;
    /* 4BL: already on the menu — a wink and a glide instead of a reload. */
    var onHome = (location.pathname === '/' || location.pathname === '') && document.querySelector('.menu-card');
    if (onHome) {
      e.preventDefault();
      /* F10 (Code review): the capture-phase intent listener fired before this
         preventDefault — clear the flags a non-navigation must not leave. */
      try { sessionStorage.removeItem('gm-nav'); sessionStorage.removeItem('gm-nav-trail'); sessionStorage.removeItem('gm-carry'); sessionStorage.removeItem('gm-nav-clean'); } catch (x) {}
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      if (logo.hasAttribute('data-menu-home')) {
        var toast = document.querySelector('.gm-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.className = 'gm-toast';
          toast.setAttribute('role', 'status');
          toast.textContent = "you\u2019re already seated \u2014 this is the menu";
          document.body.appendChild(toast);
        }
        toast.classList.add('is-on');
        window.clearTimeout(toast._t);
        toast._t = window.setTimeout(function () { toast.classList.remove('is-on'); }, 2200);
      }
      return;
    }
    /* 4JA: the logo is a RESET, not a return (Daniel's ruling, supersedes
       4BD) — no home-restore flag, and the menu's stored spot is wiped so
       arrival is the top of the card. Back buttons keep exact-spot restores;
       that contrast is the point. */
    try {
      sessionStorage.removeItem('gm-home-restore');
      sessionStorage.removeItem('gm-scroll:/');
      sessionStorage.setItem('gm-nav-clean', '1');
    } catch (x) {}
  });

  /* ── Navigation wrapper (historic 4BT shell; contents replaced by 4EI + 4DX —
        Code review F5: label corrected, structure verified balanced). ── */
  (function () {
  /* ── 4EI: NAVIGATION INTENT — the theme declares its own internal hops
     instead of trusting document.referrer (the editor iframe strips it, which
     silently killed every referred-gated restore in there). Continuity links
     additionally hand their scroll to the next page. ── */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var u;
    try { u = new URL(a.href, location.origin); } catch (x) { return; }
    if (u.origin !== location.origin) return;
    try {
      sessionStorage.setItem('gm-nav', '1');
      sessionStorage.setItem('gm-nav-trail', '1');
      /* 4HD: the MARK is the front door — arriving at the menu through the
         logo (header or card crest) is a CLEAN SLATE: no preview restore.
         Back arrivals keep their memory; that contrast is the point. */
      if (e.target.closest('.g-header__logo, [data-menu-home], .menu-card__mark-link')) {
        sessionStorage.setItem('gm-nav-clean', '1');
        /* 4JA: a mark click wipes the menu's stored spot too — the restore
           machinery finds nothing and the arrival is the top. */
        sessionStorage.removeItem('gm-home-restore');
        sessionStorage.removeItem('gm-scroll:/');
      }
      if (e.target.closest('.g-dish__thumb-wrap, .menu-line__chip')) {
        sessionStorage.setItem('gm-carry', String(window.scrollY));
        /* 4FG: colour switches anchor the ELEMENT, not the number — sibling
           pages differ in height above the strip, so raw Y lands it at a
           different viewport spot (the "heavy jump"). Remember where the
           served-in strip sits in the viewport; the arrival re-seats it there. */
        var strip = e.target.closest('.g-dish__thumb-wrap') && document.querySelector('.g-dish__served');
        if (strip) {
          try { sessionStorage.setItem('gm-carry-anchor', String(Math.round(strip.getBoundingClientRect().top))); } catch (x) {}
        }
        /* 4FI: a colour switch is the SAME room in different lighting — the
           trail replaces the current entry instead of pushing, so back walks
           rooms, never colourways. */
        if (e.target.closest('.g-dish__thumb-wrap')) {
          try { sessionStorage.setItem('gm-nav-replace', '1'); } catch (x) {}
        }
      }
    } catch (x) {}
  }, true);

  /* ── 4DX (supersedes 4DU + the referrer back): the DIRECTIONAL TRAIL.
     A position pointer walks a session history: back decrements, forward
     increments, a new room truncates the forward branch. LEFT always offers
     the room you came from plus a standing menu escape; RIGHT exists only
     when you have stepped back — so the two sides can never duplicate. All
     controls are plain links; the veil + restore handle arrival feel. ── */
  (function () {
    var q = '';
    try {
      var v = new URLSearchParams(location.search).get('variant');
      if (v) q = '?variant=' + encodeURIComponent(v);
    } catch (x) {}
    var here = location.pathname + q;
    var isHome = document.body.classList.contains('template-index') || location.pathname === '/';
    function roomLabel() {
      var t = '';
      var h = document.querySelector('main h1, h1');
      if (h) t = (h.textContent || '').trim();
      if (!t) {
        var seg = location.pathname.split('/').filter(Boolean);
        if (seg[0] === 'cart') t = 'your bag';
        else if (seg[1]) t = seg[1].replace(/-/g, ' ');
      }
      t = t.toLowerCase().replace(/\s+/g, ' ');
      if (t.length > 26) t = t.slice(0, 25).replace(/\s+\S*$/, '') + '\u2026';
      return t || 'the last room';
    }
    /* 4DZ: a DIRECT open or reload starts a FRESH journey — the inherited
       trail (same tab, earlier session, another theme preview, the editor) is
       wiped so nothing stale offers itself. Only back/forward arrivals and
       in-site hops continue a journey. */
    var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var navT = navEntry ? navEntry.type : 'navigate';
    var referred = false;
    try { referred = sessionStorage.getItem('gm-nav-trail') === '1'; sessionStorage.removeItem('gm-nav-trail'); } catch (x) {}
    var replaceHop = false;
    try { replaceHop = sessionStorage.getItem('gm-nav-replace') === '1'; sessionStorage.removeItem('gm-nav-replace'); } catch (x) {}
    var journeying = navT === 'back_forward' || (navT === 'navigate' && referred);
    var st = { list: [], i: -1 };
    if (journeying) {
      try { var raw = JSON.parse(sessionStorage.getItem('gmTrail2') || 'null'); if (raw && raw.list) st = raw; } catch (x) {}
    }
    var cur = st.list[st.i];
    /* 4GC: rooms MATCH BY PATHNAME — the editor decorates URLs with its own
       params (which broke exact matching and re-grew popped circles), and a
       colourway variant param is the same room by definition. */
    var roomKey = function (u) {
      try { return new URL(u, location.origin).pathname; } catch (x) { return String(u || '').split('?')[0]; }
    };
    var hereKey = roomKey(here);
    if (!cur || roomKey(cur.u) !== hereKey) {
      var p = st.list[st.i - 1], nx = st.list[st.i + 1];
      if (p && roomKey(p.u) === hereKey) st.i--;
      else if (nx && roomKey(nx.u) === hereKey) st.i++;
      else if (replaceHop && st.i >= 0 && journeying) {
        /* 4FI: same room, new lighting — the entry updates in place; the
           forward branch (if any) survives untouched. */
        st.list[st.i] = { u: here, l: isHome ? 'the menu' : roomLabel() };
      }
      else {
        st.list = st.list.slice(0, st.i + 1);
        st.list.push({ u: here, l: isHome ? 'the menu' : roomLabel() });
        if (st.list.length > 15) { var drop = st.list.length - 15; st.list = st.list.slice(drop); st.i -= drop; }
        st.i = st.list.length - 1;
      }
    } else {
      cur.l = isHome ? 'the menu' : roomLabel();
    }
    /* 4HB: TRAIL SELF-NORMALISATION — circles are structurally impossible.
       Whatever seeds a bad state (the editor's preview reloads wiping the
       trail mid-walk and re-recording rooms already behind you), the list
       heals on every arrival: adjacent duplicate rooms merge, and any
       A-B-A triple collapses to its single A, so back always unwinds to
       the menu and can never orbit a pair of rooms. */
    (function normalise() {
      /* 4HC: restart-on-change loop — splicing shrinks the list, so each
         heal rescans from the end instead of walking a stale index (the
         4HB version could read past the end mid-collapse and throw).
         List is capped at 15, so the cost is nothing. */
      var k = function (e) { return roomKey(e.u); };
      var changed = true;
      while (changed) {
        changed = false;
        for (var j = st.list.length - 1; j > 0; j--) {
          if (k(st.list[j]) === k(st.list[j - 1])) { st.list.splice(j, 1); if (st.i >= j) st.i--; changed = true; break; }
        }
        if (changed) continue;
        for (var j2 = st.list.length - 1; j2 > 1; j2--) {
          if (k(st.list[j2]) === k(st.list[j2 - 2])) {
            st.list.splice(j2 - 1, 2);
            if (st.i >= j2) st.i -= 2; else if (st.i === j2 - 1) st.i = j2 - 2;
            changed = true; break;
          }
        }
      }
      if (st.i > st.list.length - 1) st.i = st.list.length - 1;
      if (st.i < 0 && st.list.length) st.i = 0;
    })();
    try { sessionStorage.setItem('gmTrail2', JSON.stringify(st)); } catch (x) {}

    /* 4HE: HISTORY MIRROR — the loop Daniel diagrammed: every trail-back
       click navigated normally, PUSHING a history entry, so after one unwind
       the browser's own back pointed FORWARD again (home,pdp,bud,pdp). The
       mirror tracks the browser stack; when the trail's back target IS the
       browser's previous entry, the control calls history.back() instead of
       navigating — no entry pushed, both back buttons walk the same
       staircase down to the menu. Drift resets the mirror harmlessly (the
       control just falls back to plain navigation). */
    var hm = { h: [], p: -1 };
    try { var hraw = JSON.parse(sessionStorage.getItem('gmHist') || 'null'); if (hraw && hraw.h) hm = hraw; } catch (x) {}
    var hereK = roomKey(location.pathname);
    if (navT === 'back_forward') {
      if (hm.h[hm.p - 1] === hereK) hm.p--;
      else if (hm.h[hm.p + 1] === hereK) hm.p++;
      else { hm.h = [hereK]; hm.p = 0; }
    } else if (navT === 'reload') {
      if (hm.h[hm.p] !== hereK) { hm.h = [hereK]; hm.p = 0; }
    } else {
      hm.h = hm.h.slice(0, hm.p + 1); hm.h.push(hereK); hm.p = hm.h.length - 1;
    }
    try { sessionStorage.setItem('gmHist', JSON.stringify(hm)); } catch (x) {}

    var backRoom = st.list[st.i - 1] || null;
    var fwdRoom = st.list[st.i + 1] || null;

    /* LEFT: the room you came from; menu escape stands beneath when that room
       isn't the menu. On the menu itself, no back. */
    var backEl = document.querySelector('[data-gm-back]');
    document.querySelectorAll('.gm-back-menu').forEach(function (n) { n.parentNode.removeChild(n); });
    /* 4GA (default): ONE-WAY UNWIND — back pops your actual steps, one room
       per tap, no leapfrogging, and lands at the menu as the floor. No forward
       control exists (one-way is what prevents circles), and returning to the
       room you just left counts as a step back (the state layer's pop rule),
       so bouncing can never inflate the path. Colour switches replace, never
       add. The bidirectional trail stays dormant (window.gmTrailFancy). */
    if (!window.gmTrailFancy) {
      document.querySelectorAll('.gm-forward').forEach(function (n) { n.parentNode.removeChild(n); });
      if (backEl) {
        if (isHome) { backEl.hidden = true; }
        else if (backRoom) {
          backEl.hidden = false;
          backEl.href = backRoom.u;
          backEl.textContent = '\u2190 back to ' + (backRoom.u === '/' ? 'the menu' : backRoom.l);
          /* 4HE: unwind through real history when the entry behind us is the
             trail's target — the click sets the journey flags first so the
             arrival still reads as an in-house hop. */
          if (hm.h[hm.p - 1] === roomKey(backRoom.u)) {
            backEl.addEventListener('click', function (ev) {
              ev.preventDefault();
              try { sessionStorage.setItem('gm-nav', '1'); sessionStorage.setItem('gm-nav-trail', '1'); } catch (x) {}
              history.back();
            });
          }
          /* the instant escape rides the same line as a plain word whenever
             the true back isn't already the menu */
          if (backRoom.u !== '/') {
            var sep = document.createElement('span');
            sep.className = 'gm-back-menu gm-back-sep';
            sep.textContent = ' \u00B7 ';
            sep.setAttribute('aria-hidden', 'true');
            var esc = document.createElement('a');
            esc.className = 'gm-back gm-back-menu gm-back--word';
            esc.href = '/';
            esc.textContent = 'the menu';
            backEl.parentNode.insertBefore(sep, backEl.nextSibling);
            backEl.parentNode.insertBefore(esc, sep.nextSibling);
          }
        } else {
          backEl.hidden = false;
          backEl.href = '/';
          backEl.textContent = '\u2190 back to the menu';
        }
      }
      return;
    }
    if (backEl) {
      if (isHome) {
        backEl.hidden = true;
      } else if (backRoom) {
        backEl.hidden = false;
        backEl.href = backRoom.u;
        backEl.textContent = '\u2190 back to ' + backRoom.l;
        /* 4FY: ONE line, ONE arrow — the true back keeps its arrow; when it
           isn't the menu, the standing escape joins the same line as a quiet
           plain-word destination after a middot (4EC grammar: arrows are
           journey, destinations are words). No stacked crumbs. */
        if (backRoom.u !== '/') {
          var sep = document.createElement('span');
          sep.className = 'gm-back-menu gm-back-sep';
          sep.textContent = ' \u00B7 ';
          sep.setAttribute('aria-hidden', 'true');
          var esc = document.createElement('a');
          esc.className = 'gm-back gm-back-menu gm-back--word';
          esc.href = '/';
          esc.textContent = 'the menu';
          backEl.parentNode.insertBefore(sep, backEl.nextSibling);
          backEl.parentNode.insertBefore(esc, sep.nextSibling);
        }
      } else {
        backEl.hidden = false;
        backEl.href = '/';
        backEl.textContent = '\u2190 back to the menu';
      }
    }

    /* RIGHT: only a stepped-back journey has a forward. */
    document.querySelectorAll('.gm-forward').forEach(function (n) { n.parentNode.removeChild(n); });
    if (fwdRoom) {
      var fwd = document.createElement('a');
      fwd.href = fwdRoom.u;
      fwd.textContent = 'return to ' + fwdRoom.l + ' \u2192';
      var band = isHome ? document.querySelector('.menu-card__band') : null;
      if (band) {
        fwd.className = 'gm-forward gm-forward--band';
        band.insertBefore(fwd, band.children[1] || null);
      } else {
        fwd.className = 'gm-forward';
        document.body.appendChild(fwd);
      }
    }
  })();

})();

/* ── 4AZ: homepage logo handoff — when the menu card's mark leaves the
        viewport, the header logo fades in; when it returns, the header yields. ── */
  (function () {
    var handoff = document.querySelector('.g-header__logo--handoff');
    var mark = document.querySelector('.menu-card__mark');
    if (handoff && mark && 'IntersectionObserver' in window) {
      /* 4BE: the mark counts as gone the moment it slips UNDER the fixed header,
         not when it leaves the whole viewport — kills the handoff lag. */
      var gmHeaderH = (getComputedStyle(document.documentElement).getPropertyValue('--g-header-height') || '70px').trim();
      var markIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          handoff.classList.toggle('is-shown', !en.isIntersecting);
        });
      }, { threshold: 0, rootMargin: '-' + gmHeaderH + ' 0px 0px 0px' });
      markIO.observe(mark);
    }
  })();

  /* ── Subscribe dropdown (desktop header) ── */
  /* 4FL: the header's favourites word — opens the bag drawer scrolled to the
     favourites section; count mirrors the client-side set. */
  var favsToggle = document.getElementById('favsToggle');
  var favsCount = document.getElementById('favsCount');
  function gmSyncFavsWord() {
    if (!favsCount) return;
    var n = (window.gmFavourites && window.gmFavourites.list().length) || 0;
    favsCount.textContent = n ? ' (' + n + ')' : '';
  }
  if (favsToggle) favsToggle.addEventListener('click', function () {
    var t = document.getElementById('cartToggle'); if (t) t.click();
    window.setTimeout(function () {
      var sec = document.querySelector('[data-cart-fav]');
      if (sec && !sec.hidden) sec.scrollIntoView({ block: 'start', behavior: 'auto' });
    }, 200);
  });
  window.addEventListener('storage', gmSyncFavsWord);
  document.addEventListener('click', function () { window.setTimeout(gmSyncFavsWord, 50); });
  document.addEventListener('DOMContentLoaded', gmSyncFavsWord);
  gmSyncFavsWord();

  var subscribeToggle = document.getElementById('subscribeToggle');
  var subscribeDropdown = document.getElementById('subscribeDropdown');

  if (subscribeToggle && subscribeDropdown) {
    /* 4EJ: PORTAL — the dropdown escapes its section wrapper. Inside the theme
       editor the selected section's highlight overlay eats pointer events over
       everything in its box (untypeable inputs, taps that close it); and any
       transformed ancestor would degrade fixed positioning. On body, neither
       can touch it. */
    if (subscribeDropdown.parentNode !== document.body) document.body.appendChild(subscribeDropdown);
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-subscribe-close]')) subscribeDropdown.classList.remove('is-open');
    });
    subscribeToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      subscribeDropdown.classList.toggle('is-open');
    });

    document.addEventListener('click', function(e) {
      if (!subscribeDropdown.contains(e.target) && e.target !== subscribeToggle) {
        subscribeDropdown.classList.remove('is-open');
      }
    });

    var headerSubForm = document.getElementById('HeaderSubscribeForm');
    if (headerSubForm) {
      headerSubForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = headerSubForm.querySelector('input[type="email"]');
        if (!email || !email.value) return;

        /* 4CP: phone is optional data — a malformed one must never sink the
           signup. Strip it from the payload rather than block. */
        var fd = new FormData(headerSubForm);
        var ph = (fd.get('contact[phone]') || '').toString().trim();
        if (ph && !/^\+?[0-9\s()\-\.]{7,}$/.test(ph)) fd.delete('contact[phone]');

        fetch(headerSubForm.action, { method: 'POST', body: fd });

        document.getElementById('subscribeFormInner').style.display = 'none';
        document.getElementById('subscribeThanks').style.display = 'block';

        setTimeout(function() {
          document.getElementById('subscribeFormInner').style.display = 'flex';
          document.getElementById('subscribeThanks').style.display = 'none';
          headerSubForm.reset();
          subscribeDropdown.classList.remove('is-open');
        }, 2500);
      });
    }
  }

  /* ── Mobile SUBSCRIBE link → scroll to footer + open popup ── */
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/#footer-newsletter"], a[href*="/subscribe"]');
    if (!link || window.innerWidth >= 750) return;
    e.preventDefault();

    // Close mobile drawer if open

    setTimeout(function() {
      // Find and click the footer subscribe trigger
      var subscribeTrigger = document.querySelector('[data-popup="subscribe"]');
      if (subscribeTrigger) {
        subscribeTrigger.click();
        setTimeout(function() {
          subscribeTrigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var emailInput = document.querySelector('[data-popup-panel="subscribe"] input[type="email"]');
          if (emailInput) emailInput.focus();
        }, 150);
      }
    }, 400);
  });

  /* ── Footer popups ── */
  document.querySelectorAll('.g-popup-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var name = this.dataset.popup;
      var panel = document.querySelector('[data-popup-panel="' + name + '"]');
      var isOpen = panel && panel.classList.contains('is-open');

      // Close all
      document.querySelectorAll('[data-popup-panel]').forEach(function(p) { p.classList.remove('is-open'); });
      document.querySelectorAll('.g-popup-trigger').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen && panel) {
        panel.classList.add('is-open');
        this.classList.add('is-active');
        this.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          panel.scrollIntoView({ block: 'end', behavior: reduce ? 'auto' : 'smooth' });
        });
      }
    });
  });

  /* footer popups: a plain close word on every plate. */
  document.querySelectorAll('[data-popup-panel]').forEach(function(p) {
    if (p.querySelector('.g-footer__popup-close')) return;
    var xc = document.createElement('button');
    xc.type = 'button';
    xc.className = 'g-footer__popup-close';
    xc.textContent = 'close';
    xc.addEventListener('click', function(ev) {
      ev.stopPropagation();
      p.classList.remove('is-open');
      document.querySelectorAll('.g-popup-trigger').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-expanded', 'false');
      });
    });
    p.insertBefore(xc, p.firstChild);
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.g-footer__popup-wrap')) {
      document.querySelectorAll('[data-popup-panel]').forEach(function(p) { p.classList.remove('is-open'); });
      document.querySelectorAll('.g-popup-trigger').forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ── Footer subscribe form ── */
  var footerSubForm = document.getElementById('FooterSubscribeForm');
  if (footerSubForm) {
    footerSubForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = footerSubForm.querySelector('input[type="email"]');
      if (!email || !email.value) return;

      var formRow = footerSubForm.querySelector('.g-footer__subscribe-row');
      var thanks = document.getElementById('footerSubThanks');

      /* 4CP: same guard as the header — optional phone never sinks the signup. */
      var fd = new FormData(footerSubForm);
      var ph = (fd.get('contact[phone]') || '').toString().trim();
      if (ph && !/^\+?[0-9\s()\-\.]{7,}$/.test(ph)) fd.delete('contact[phone]');

      fetch(footerSubForm.action, { method: 'POST', body: fd });

      if (formRow) formRow.style.display = 'none';
      if (thanks) thanks.style.display = 'block';

      setTimeout(function() {
        if (formRow) formRow.style.display = 'flex';
        if (thanks) thanks.style.display = 'none';
        footerSubForm.reset();
      }, 2500);
    });
  }

  /* ── Cart drawer ── */
  var cartToggle = document.getElementById('cartToggle');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartClose = document.getElementById('cartDrawerClose');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  }

  /* 4DY: the bag word TOGGLES — press to open, press again to close. */
  if (cartToggle) cartToggle.addEventListener('click', function () {
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart(); else openCart();
  });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* 4AT (amended 4DA): Escape closes the drawer and the subscribe dropdown —
     one dismissal grammar. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
    var sub = document.querySelector('.g-subscribe-dropdown.is-open');
    if (sub) sub.classList.remove('is-open');
  });

  /* Cart: update quantity */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.dataset.action;
    var line = btn.dataset.line;
    if (!line) return;

    var updates = {};
    if (action === 'remove') {
      updates = { line: parseInt(line), quantity: 0 };
    } else if (action === 'decrease') {
      var qty = btn.closest('.g-cart-item__qty')?.querySelector('span');
      var current = qty ? parseInt(qty.textContent) : 1;
      updates = { line: parseInt(line), quantity: Math.max(0, current - 1) };
    } else if (action === 'increase') {
      var qty2 = btn.closest('.g-cart-item__qty')?.querySelector('span');
      var current2 = qty2 ? parseInt(qty2.textContent) : 1;
      updates = { line: parseInt(line), quantity: current2 + 1 };
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates)
    })
    .then(function(r) { return r.json(); })
    .then(function() { refreshCartDrawer(); });
  });

  /* Refresh cart drawer via Section Rendering API */
  window.refreshCartDrawer = function() {
    fetch('/?sections=glomesh-cart-drawer')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['glomesh-cart-drawer'];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newBody = doc.querySelector('.g-cart-drawer__body');
        var oldBody = document.querySelector('.g-cart-drawer__body');
        if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;

        var newFoot = doc.querySelector('.g-cart-drawer__foot');
        var oldFoot = document.querySelector('.g-cart-drawer__foot');
        if (newFoot && oldFoot) oldFoot.innerHTML = newFoot.innerHTML;

        /* 4FQ: the repaint ANNOUNCES itself — replacing the body resets the
           favourites section to its server default, and the renderer (which
           listens for this event) must repaint it. This half of the contract
           was missing: remove/quantity wiped favourites until next open. */
        document.dispatchEvent(new CustomEvent('cart:updated'));

        // Update header cart count from cart API
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEl = document.getElementById('cartCount');
            if (countEl) {
              countEl.textContent = cart.item_count > 0 ? cart.item_count : '';
            }
          });
      });
  };

  /* Listen for add-to-cart events (used by product page) */
  window.addToCart = function(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      openCart();
      var body = document.querySelector('.g-cart-drawer__body');
      if (body) body.innerHTML = '<div style="text-align:center;padding:30px 20px;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:rgba(255,255,255,0.5);">ADDING...</div>';
      return fetch('/?sections=glomesh-cart-drawer')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data['glomesh-cart-drawer'];
          if (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newBody = doc.querySelector('.g-cart-drawer__body');
            var oldBody = document.querySelector('.g-cart-drawer__body');
            if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
            var newFoot = doc.querySelector('.g-cart-drawer__foot');
            var oldFoot = document.querySelector('.g-cart-drawer__foot');
            if (newFoot && oldFoot) oldFoot.innerHTML = newFoot.innerHTML;
          }
          return fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var countEl = document.getElementById('cartCount');
              if (countEl) countEl.textContent = cart.item_count > 0 ? cart.item_count : '';
              return item;
            });
        });
    });
  };

  /* ── Homepage: scroll to top on load ── */
  if (document.body.classList.contains('template-index')) {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
  }

  /* ── Collection/Search tile gallery (shared) ── */
  window.initTileGalleries = function(selector) {
    var isMobile = window.innerWidth < 750;

    document.querySelectorAll(selector || '.g-tile[data-images]').forEach(function(tile) {
      var raw = tile.dataset.images;
      var count = parseInt(tile.dataset.imageCount, 10);
      if (!raw || count < 2) return;

      var images = raw.split('|||');
      var img = tile.querySelector('.g-tile__image img');
      if (!img) return;

      var current = 0;
      var prevBtn = tile.querySelector('.g-tile__arrow--prev');
      var nextBtn = tile.querySelector('.g-tile__arrow--next');
      var dotFill = tile.querySelector('.g-tile__dot-fill');

      // Preload
      images.forEach(function(src) { new Image().src = src; });

      function goTo(n) {
        current = (n + images.length) % images.length;
        img.style.opacity = '0';
        setTimeout(function() {
          img.src = images[current];
          img.removeAttribute('srcset');
          img.style.opacity = '1';
        }, 100);
        if (dotFill) {
          dotFill.style.transform = 'translateX(' + (current * 100) + '%)';
        }
      }

      var isHovering = false;
      var hoverDisabled = false;

      // Desktop arrows
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          goTo(current - 1);
          hoverDisabled = true;
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          if (isHovering) {
            goTo(current + 2);
          } else {
            goTo(current + 1);
          }
          hoverDisabled = true;
        });
      }

      // Desktop: hover preview + mouse leave always reverts to image 0 AND re-enables hover
      if (!isMobile) {
        tile.addEventListener('mouseenter', function() {
          if (images.length < 2) return;
          if (hoverDisabled) return;
          isHovering = true;
          var previewIdx = (current + 1) % images.length;
          img.style.opacity = '0';
          setTimeout(function() {
            img.src = images[previewIdx];
            img.removeAttribute('srcset');
            img.style.opacity = '1';
          }, 100);
        });
        tile.addEventListener('mouseleave', function() {
          isHovering = false;
          hoverDisabled = false;
          current = 0;
          img.style.opacity = '0';
          setTimeout(function() {
            img.src = images[0];
            img.removeAttribute('srcset');
            img.style.opacity = '1';
          }, 100);
        });
      }

      // Mobile: MM tiles auto-cycle once on scroll into view (independent random delays)
      if (tile.dataset.mm === 'true' && images.length >= 2 && !tile.dataset.cycled) {
        var mmObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting || tile.dataset.cycled) return;
            tile.dataset.cycled = 'true';
            mmObserver.unobserve(tile);
            var delay = Math.random() * 2500;
            setTimeout(function() {
              var originalTransition = img.style.transition;
              img.style.transition = 'opacity 0.6s ease';
              img.style.opacity = '0';
              setTimeout(function() {
                img.src = images[1];
                img.removeAttribute('srcset');
                img.style.opacity = '1';
                setTimeout(function() {
                  img.style.opacity = '0';
                  setTimeout(function() {
                    img.src = images[0];
                    img.removeAttribute('srcset');
                    img.style.opacity = '1';
                    setTimeout(function(){ img.style.transition = originalTransition; }, 700);
                  }, 600);
                }, 2000);
              }, 600);
            }, delay);
          });
        }, { threshold: 0.5 });
        mmObserver.observe(tile);
      }

      // Mobile: swipe
      if (isMobile) {
        var touchStartX = 0, touchStartY = 0, swiped = false;
        var imageDiv = tile.querySelector('.g-tile__image');
        if (!imageDiv) return;

        imageDiv.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          swiped = false;
        }, { passive: true });

        imageDiv.addEventListener('touchend', function(e) {
          var diffX = touchStartX - e.changedTouches[0].clientX;
          var diffY = touchStartY - e.changedTouches[0].clientY;
          if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 30) {
            swiped = true;
            goTo(diffX > 0 ? current + 1 : current - 1);
          }
        }, { passive: true });

        tile.addEventListener('click', function(e) {
          if (swiped) { e.preventDefault(); swiped = false; }
        });
      }
    });
  };

  /* ── Scroll navigator (collection pages) ── */
  if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-list-collections')) {
    var scrollNav = document.createElement('div');
    scrollNav.id = 'g-scroll-nav';
    scrollNav.style.cssText = 'position:fixed;right:20px;bottom:30px;z-index:9998;';
    scrollNav.innerHTML = '<button id="g-scroll-btn" style="background:#0a0a0a;color:#fff;border:none;width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:9px;opacity:0.7;transition:opacity 0.2s;" aria-label="Scroll">&#9660;&#xFE0E;</button>';
    document.body.appendChild(scrollNav);

    var scrollBtn = document.getElementById('g-scroll-btn');
    var atBottom = false;

    scrollBtn.addEventListener('click', function() {
      window.scrollTo({ top: atBottom ? 0 : document.body.scrollHeight, behavior: 'smooth' });
    });

    window.addEventListener('scroll', function() {
      atBottom = window.scrollY + window.innerHeight >= document.body.scrollHeight - 100;
      scrollBtn.innerHTML = atBottom ? '&#9650;&#xFE0E;' : '&#9660;&#xFE0E;';
    }, { passive: true });
  }

  /* ── Mobile: auto-hide scroll hint after 6 seconds ── */
  var scrollHint = document.getElementById('glomeshScrollHint');
  if (scrollHint) {
    setTimeout(function() {
      scrollHint.style.transition = 'opacity 1s ease';
      scrollHint.style.opacity = '0';
      setTimeout(function() {
        scrollHint.style.display = 'none';
      }, 1000);
    }, 6000);
  }
  /* ── Klaviyo Back in Stock ── */
  var bisTrigger = document.getElementById('bisTrigger');
  var bisForm = document.getElementById('bisForm');
  var bisEmail = document.getElementById('bisEmail');
  var bisSubmit = document.getElementById('bisSubmit');
  var bisThanks = document.getElementById('bisThanks');
  var bisWrap = document.getElementById('glomeshBIS');

  if (bisTrigger && bisForm && !bisTrigger.dataset.bound) {
bisTrigger.dataset.bound = 'true';

    bisTrigger.addEventListener('click', function() {
      if (bisForm.style.display === 'flex') {
        bisForm.style.display = 'none';
        bisTrigger.textContent = 'NOTIFY ME WHEN AVAILABLE';
      } else {
        bisForm.style.display = 'flex';
        bisTrigger.textContent = 'CLOSE';
        bisEmail.focus();
      }
    });

    bisSubmit.addEventListener('click', function() {
      var email = bisEmail.value;
      if (!email) return;

      var variantId = bisWrap.dataset.variantId;
      var productId = bisWrap.dataset.productId;

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WnZQJZ', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      })
      .then(function() {
        bisForm.style.display = 'none';
        bisThanks.style.display = 'block';
        setTimeout(function() {
          bisThanks.style.display = 'none';
          bisTrigger.textContent = 'NOTIFY ME WHEN AVAILABLE';
          bisTrigger.style.display = 'block';
          bisEmail.value = '';
        }, 3000);
      })
      .catch(function() {
        bisForm.style.display = 'none';
        bisThanks.style.display = 'block';
        setTimeout(function() {
          bisThanks.style.display = 'none';
          bisTrigger.textContent = 'NOTIFY ME WHEN AVAILABLE';
          bisTrigger.style.display = 'block';
          bisEmail.value = '';
        }, 3000);
      });
    });
  }
})();


/* 4IX-js: MOBILE TRAIL PILL — inline on the element, cascade-proof. On phones
   the trail becomes one floating gold arrow in a hairline pill; the separator
   and escape word step aside. Desktop untouched. */
(function () {
  function pill() {
    return; /* 4IX-js retired — the header's ← is CSS-drawn (4JH) */
    var b = document.querySelector('[data-gm-back]');
    if (!b || b.hidden) return;
    b.textContent = '\u2190';
    var s = b.style;
    s.position = 'fixed';
    s.top = 'calc(env(safe-area-inset-top, 0px) + 10px)';
    s.left = '10px';
    s.zIndex = '70';
    s.width = '40px';
    s.height = '38px';
    s.boxSizing = 'border-box';
    s.padding = '0';
    s.lineHeight = '36px';
    s.textAlign = 'center';
    s.fontSize = '18px';
    s.color = '#C4A882';
    s.background = '#1C1611';
    s.border = '1px solid rgba(196,168,130,.45)';
    s.borderRadius = '999px';
    s.textDecoration = 'none';
    document.querySelectorAll('.gm-back-menu').forEach(function (n) { n.style.display = 'none'; });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(pill, 60); });
  } else {
    window.setTimeout(pill, 60);
  }
  window.addEventListener('pageshow', function () { window.setTimeout(pill, 120); });
})();